import Card_right from "../components/CardRight";

export default function Detaljer() {
  return (
      <Card_right>
        <div className="card-right-title">Detaljer</div>
        <div className="card-right-content">
          <p>
            Vi sier JA til hverandre kl. 12.30 i Ås kirke (
            <a
              href="https://maps.app.goo.gl/ei7XaH1fYSYBgwwP7"
              target="_blank"
              rel="noopener noreferrer"
            >
              Kirkeveien 35, 1433 Ås
            </a>
            ).
          </p>

          <p>
            Etter vielsen vil vi forsvinne for å ta litt bilder, men på Gælja (
            <a
              href="https://maps.app.goo.gl/h3epJQ5ErVkrenDr8"
              target="_blank"
              rel="noopener noreferrer"
            >
              Kolåsveien 30, 1553 Son
            </a>
            ) vil det være mulig å komme og få litt ventemat fra kl. 14.30. Brudeparet ankommer senest 16.30. 
          </p>

          <p>
            Middagen er kl. 17.00.
          </p>

          <p>
            For mer informasjon kan dere bla videre nedover til "Praktisk informasjon" og for informasjon om toastmaster kan dere bla ned til "Underholdning".
          </p>

          <p>
            Nettsiden blir kanskje oppdatert med mer informasjon etter hvert, så sørg for at dere sjekker tilbake når den store dagen nærmer seg.
          </p>
          <p>
            Vi gleder oss til å feire denne spesielle dagen med dere!
          </p>
        </div>
      </Card_right>
  );
}
